
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"64","height":"20","rx":"2","fill":"#000"}}),_c('g',{attrs:{"clip-path":"url(#clip0_2_218)","fill":"#fff"}},[_c('path',{attrs:{"d":"M15.13 6h-1.178v6.642h1.178V6zM7.178 7.359H6V14h1.178V7.359zM9.829 6.906H8.65v6.641h1.178V6.906zM12.48 6.453H11.3v6.641h1.178V6.453zM47.94 9.819l-2-2.246h-1.17v5.2h1.221V9.454l1.827 1.965h.226l1.796-1.965v3.317h1.221V7.573h-1.17l-1.95 2.246zM56.881 7.573l-3.028 3.38v-3.38h-1.221v5.2h1.12l3.026-3.38v3.38H58v-5.2h-1.119zM38.19 9.476c0 .827.45 1.48 1.138 1.753l-1.291 1.543h1.495l1.174-1.404h1.27v1.404h1.222V7.573h-3.11c-1.159 0-1.897.8-1.897 1.903zm3.788-.758v1.538h-1.663c-.555 0-.852-.312-.852-.77 0-.457.308-.77.852-.77l1.663.002zM32.514 8.613c-.075 1.788-.448 2.942-1.18 2.942h-.183v1.248l.195.01c1.467.083 2.278-1.216 2.411-4.055h1.93v4.014h1.22V7.573h-4.352l-.04 1.04zM27.916 7.5c-1.652 0-2.84 1.155-2.84 2.672 0 1.57 1.293 2.684 2.84 2.684 1.612 0 2.864-1.176 2.864-2.684 0-1.507-1.252-2.672-2.864-2.672zm0 4.107c-.934 0-1.57-.613-1.57-1.435 0-.842.637-1.439 1.57-1.439s1.59.624 1.59 1.44c0 .814-.666 1.434-1.59 1.434zM23.78 7.583h-4.312l-.04 1.04c-.062 1.498-.45 2.923-1.181 2.943l-.339.01V14h1.232v-1.227h4.28V14h1.242v-2.434h-.883V7.583zm-1.222 3.983h-2.607c.441-.676.678-1.653.719-2.797h1.888v2.797z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2_218"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(6 6)","d":"M0 0h52v8H0z"}})])])])
          )
        }
      }
    